import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

/**
 * Detects AI crawlers (ChatGPT-User, PerplexityBot live, Googlebot, etc.)
 * that execute JS, and reports the visit to the track-ai-crawler edge function.
 *
 * Pure JS-side bots like GPTBot/CCBot/ClaudeBot crawl mode do NOT execute JS
 * and will not be captured here — that requires server-side intercept.
 */
const AI_BOT_REGEX =
  /(GPTBot|ChatGPT-User|OAI-SearchBot|ClaudeBot|Claude-Web|anthropic-ai|PerplexityBot|Perplexity-User|Google-Extended|GoogleOther|Googlebot|Meta-ExternalAgent|FacebookBot|facebookexternalhit|Bytespider|CCBot|Applebot-Extended|Applebot|Bingbot|BingPreview|Copilot|YouBot|DuckAssistBot|cohere-ai|MistralAI|Diffbot)/i;

export function useAiCrawlerTracking() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;
    const ua = navigator.userAgent || "";
    if (!AI_BOT_REGEX.test(ua)) return;

    // Fire and forget — never block UX, never throw.
    try {
      supabase.functions
        .invoke("track-ai-crawler", {
          body: {
            userAgent: ua,
            url: window.location.href,
            path: location.pathname + location.search,
            referrer: document.referrer || "",
          },
        })
        .catch(() => {
          /* noop */
        });
    } catch {
      /* noop */
    }
  }, [location.pathname, location.search]);
}
